import React from 'react';
import { Fade, makeStyles } from '@material-ui/core';
import Done from '@material-ui/icons/Done';
import { Button, Input, Modal } from '../root/components/common';
import { PasswordInput } from '../root/components/common/password-input/password-input';
import { usePasswordValidate } from '../root/components/common/password-input/use-password-validate';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { profileChangePasswordRequest } from '../root/actions';
import { useBooleanState } from '../../../src/utils/hooks/useBooleanState';
import { useRef } from 'react';

export const ChangePassword = ({ onClose, ...dialogProps }) => {
    const [oldPassword, setOldPassword] = useState('')
    const [newPassword, setNewPassword] = useState('')
    const [newPasswordProof, setNewPasswordProof] = useState('')
    const { validators, isPasswordValid } = usePasswordValidate(newPassword)
    const pristine = useBooleanState(true)
    const { locale } = useSelector(state => state.main)
    const dispatch = useDispatch()
    const passwordRef = useRef()
    const classes = useStyles()

    const arePasswordsEqual = (p, pProof) => {
        return p.length > 0 && pProof.length > 0 && p === pProof
    }

    const isValid = () => {
        let ok = true
        if (!arePasswordsEqual(newPassword, newPasswordProof)) {
            ok = false
            dispatch(enqueueSnackbar({
                message: locale.resetPassword.passwordsDoNotMatch,
                options: {
                    variant: 'warning'
                }
            }))
        }
        if (!isPasswordValid) {
            ok = false
            pristine.off()
            passwordRef.current.focus()
        }
        return ok
    }

    const handleSubmit = () => {
        if (isValid()) {
            dispatch(profileChangePasswordRequest({
                old_password: oldPassword,
                new_password: newPassword
            }))
            onClose()
        }
    }

    return (
        <Modal
            size={"sm"}
            {...dialogProps}
        >
            <div className={classes.pswdInputWrapper}>
                <Input
                    className={classes.input}
                    label={locale.common.oldPassword}
                    type='password'
                    setValue={setOldPassword}
                    value={oldPassword}
                />
            </div>
            <div className={classes.pswdInputWrapper}>
                <PasswordInput
                    inputRef={passwordRef}
                    isError={!pristine.is && !isPasswordValid}
                    validators={validators}
                    className={classes.input}
                    label={locale.common.newPassword}
                    setValue={setNewPassword}
                    value={newPassword}
                />
                <Fade in={isPasswordValid} timeout={500}>
                    <Done className={classes.doneIcon} />
                </Fade>
            </div>
            <div className={classes.pswdInputWrapper}>
                <Input
                    className={classes.input}
                    label={locale.common.newPasswordConfiramtion}
                    type='password'
                    setValue={setNewPasswordProof}
                    value={newPasswordProof}
                />
                <Fade in={arePasswordsEqual(newPassword, newPasswordProof)} timeout={500}>
                    <Done className={classes.doneIcon} />
                </Fade>
            </div>
            <div className={classes.modalButtons}>
                <Button onClick={handleSubmit}>
                    {locale.common.changePassword}
                </Button>
                <Button reverted onClick={onClose}>
                    {locale.common.cancel}
                </Button>
            </div>
        </Modal>
    )
}

const useStyles = makeStyles(theme => ({
    pswdInputWrapper: {
        position: 'relative',
        width: "100%"
    },
    input: {
        marginBottom: 15
    },
    doneIcon: {
        position: 'absolute',
        color: theme.active,
        top: 10,
        right: -35
    },
    modalButtons: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 15
    }

}))